export const DesignSystem = {
    colors: {
        primary: "#0E654A",
        secondary: "#ff9800",
        accent: "#3498ff",
        violet: "#673ab7",
        gray: "#5e5e5e99",
        disabled: "#d9d9d9",
        filterBg: "#f6f8fa",
        red: "#f44336",
    },
};
